import type { FC } from 'react';

import type { CarePlanViewModel } from '@eluve/api-contract';
import { Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

export const TreatingChips: FC<{
  treating: CarePlanViewModel['treating'];
}> = ({ treating }) => {
  const { t } = useTranslation();
  if (treating.length === 0) return null;
  return (
    <Stack direction="horizontal" align="center" gap={2} wrap>
      <Text size="xs" color="secondary">
        {t('carePlans.review.treating')}
      </Text>
      {treating.map((condition) => (
        <span
          key={condition.id}
          className="rounded-full border border-border-secondary bg-bg-secondary px-2.5 py-0.5"
        >
          <Text inline size="xs">
            {condition.text}
          </Text>
        </span>
      ))}
    </Stack>
  );
};
